<script setup>
  console.log('vue setup')
</script>

<template>
  <div>Hello From VUE3</div>
</template>
